module.exports = __webpack_public_path__ + "img/map-marked-alt-solid.28b89829.svg";